module.exports = __webpack_public_path__ + "e75ba615cba5fc09ba42ca955c7ecb12.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-11-20/whats-new.html
// module id = 1915
// module chunks = 0